import {BannerTypes} from 'src/shared/constants/AppEnums';
import * as yup from 'yup';

export const schema = (messages: any) =>
  yup.object().shape({
    name: yup
      .string()
      .required(messages['product.validate.create.name'].toString()),
    attachment: yup
      .string()
      .required(
        messages['promotions.banners.validate.upload.attachment'].toString(),
      ),
    startDate: yup
      .date()
      .nullable()
      .required(messages['product.validate.create.startDate'].toString()),
    endDate: yup
      .date()
      .nullable()
      .required(messages['product.validate.create.endDate'].toString()),
    mainCategoryId: yup
      .string()
      .required(
        messages['promotion.banners.validate.create.mainCategory'].toString(),
      ),
    type: yup
      .string()
      .required(
        messages['promotion.banners.validate.create.bannerType'].toString(),
      ),
    subCategoryId: yup.string().when('type', (type, schema) => {
      if (type === BannerTypes.SubCategory)
        return schema.required(
          messages['promotion.banners.validate.subCategories'].toString(),
        );
    }),
    url: yup.string().when('type', (type, schema) => {
      if (type === BannerTypes.Url)
        return schema.required(
          messages['promotion.banners.validate.bannerURL'].toString(),
        );
    }),
  });
